import React from "react"
import { Container, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              <a href="https://ecs.com.pk/" target="blank_">
                ECS
              </a>
            </Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block"></div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
